export interface SurveyQuestion {
  type: string;
  name: string;
  tags?: string[];
  [key: string]: unknown;
}

export interface SurveyPage {
  name: string;
  elements: SurveyQuestion[];
  [key: string]: unknown;
}

export interface SurveySchema {
  pages: SurveyPage[];
  [key: string]: unknown;
}

export function filterSurveySchemaByTag(
  schema: SurveySchema,
  tag: string,
): SurveySchema {
  const filteredPages = schema.pages
    .map((page) => ({
      ...page,
      elements: page.elements.filter((question) => {
        const questionTags = question.tags || [];
        return questionTags.includes(tag);
      }),
    }))
    .filter((page) => page.elements.length > 0);

  return {
    ...schema,
    pages: filteredPages,
  };
}
